import { DailyBalance } from "../../../types";

export function formatBalanceCurrency(value: number): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
}

export const BALANCE_PAYMENT_METHOD_LABELS: Record<keyof DailyBalance["byPaymentMethod"], string> = {
  PIX: "PIX",
  Débito: "Débito",
  Crédito: "Crédito",
  Dinheiro: "Dinheiro",
};

export const BALANCE_PAYMENT_METHOD_BAR_COLORS: Record<keyof DailyBalance["byPaymentMethod"], string> = {
  PIX: "bg-[#32BCAD]",
  Débito: "bg-green-500",
  Crédito: "bg-purple-500",
  Dinheiro: "bg-yellow-500",
};

export const BALANCE_SERVICE_BAR_COLORS = [
  "bg-blue-500",
  "bg-indigo-500",
  "bg-teal-500",
  "bg-cyan-600",
  "bg-violet-500",
  "bg-sky-500",
];
